vec3 effect(vec2 uv)
{
    return heat(luma(sampleCam(uv)));
}
